exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thank-you-content{padding-left:0}.thank-you-content p{line-height:25px}@media(min-width: 64em){.thank-you-content h4{font-size:24px}}.thank-you-improvment{padding:0 20px 15px}@media(min-width: 64em){.thank-you-improvment{padding:0 40px 10px}}span.error{color:red;font-size:13px;position:relative;top:-8px}.mt74{margin-top:74px}.button-width{width:240px}", ""]);

// exports
